import {ExperimentalInputEvaluatedValues} from 'procedures/planning/ProcedurePlanTypes';

import {Condition} from '../process-development/useProcessDevelopmentStudyState';
import {MethodExecutionLimitState} from './useMethodExecutionLimitState';

export function areProcedureRunInputsEvaluatedValuesValid(
  evaluatedValues: ExperimentalInputEvaluatedValues
): boolean {
  return Object.values(evaluatedValues).every((methodData) => !methodData.hasBlockingValueErrors);
}

/* True if conditions are valid for creation, false otherwise. */
export function validateConditions(conditions: Array<Condition>): boolean {
  const conditionsValid = !conditions.some(
    ({validationState}) =>
      validationState?.isNameLengthOverLimit ||
      validationState?.isDuplicateName ||
      validationState?.isDescLengthOverLimit
  );
  return conditionsValid;
}

export function isNumConditionReplicatesValid(methodExecutionLimitState: MethodExecutionLimitState): boolean {
  return !methodExecutionLimitState.isOverLimit;
}
